import { openModal } from '../../scripts/components/modals';
import { execOnLoad } from '@general/helpers';
import './order-alert-popup.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initOrderAlertPopup = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const alertTriggers = document.querySelectorAll(
    '.btn-checkout.trigger-alert-popup',
  );
  const alertPopup = document.getElementById('OrderAlertPopup');
  if (alertPopup && alertTriggers.length > 0) {
    alertTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(alertPopup);
      });
    });
  }
};

execOnLoad(window.dAgency.initOrderAlertPopup, '.order-alert-popup__section');
